export const Sofa: React.FC<React.SVGAttributes<{}>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="66.782"
      height="48"
      viewBox="0 0 66.782 48"
      fill="currentColor"
      {...props}
    >
      <path
        id="Sofa"
        d="M100.643,196.523h-.116a6.04,6.04,0,0,0-2.092.375v-4.549A8.348,8.348,0,0,0,90.087,184H56.7a8.348,8.348,0,0,0-8.348,8.348v4.532a6.258,6.258,0,0,0-2.087-.358c-.133,0-.266,0-.4.013a6.261,6.261,0,0,0-1.687,12.151v21.227A2.086,2.086,0,0,0,46.261,232h4.174a2.086,2.086,0,0,0,2.087-2.087H94.261A2.086,2.086,0,0,0,96.348,232h4.174a2.086,2.086,0,0,0,2.087-2.087V208.686a6.261,6.261,0,0,0-1.966-12.163Zm-50.208,33.39H46.261V208.686a2.086,2.086,0,0,0-1.391-1.967,4.154,4.154,0,0,1-2.778-4.151,4.211,4.211,0,0,1,3.9-3.951c.09-.005.181-.008.27-.008a4.178,4.178,0,0,1,4.174,4.174Zm43.826-2.087H52.522v-6.261H94.261Zm-41.739-8.348v-6.261H70.261a2.089,2.089,0,0,1,2.087,2.087v4.174Zm41.739,0H74.435V215.3a2.089,2.089,0,0,1,2.087-2.087H94.261Zm0-16.555v8.207H76.522a4.161,4.161,0,0,0-3.13,1.419,4.161,4.161,0,0,0-3.13-1.419H52.522v-8.348a6.245,6.245,0,0,0-2.087-4.665v-5.769a6.269,6.269,0,0,1,6.261-6.261H90.087a6.269,6.269,0,0,1,6.261,6.261v5.831A6.467,6.467,0,0,0,94.261,202.923Zm7.652,3.8a2.086,2.086,0,0,0-1.391,1.967v21.227H96.348v-26.99a4.306,4.306,0,0,1,4.179-4.315h.076a4.174,4.174,0,0,1,1.31,8.109Z"
        transform="translate(-40 -184)"
        fill="currentColor"
      />
    </svg>
  );
};
